import { render, staticRenderFns } from "./FluxFondosClassicStep1.vue?vue&type=template&id=31b0273c"
import script from "./FluxFondosClassicStep1.vue?vue&type=script&lang=js"
export * from "./FluxFondosClassicStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports